export default __webpack_public_path__ + "static/media/bajaj.30c33145.png";